export const getReformattedSummary = (data) => {
    return data.reduce(
        (acc, current) => {
            acc.chartData.labels.push(current._id.month);
            const leave = current.leave.reduce(
                (acc_, _current) => {
                    acc_[_current.type] = _current.total;
                    return acc_;
                },
                { vl: 0, sl: 0 }
            );
            acc.chartData.dataSets[0].data.push(leave.vl);
            acc.chartData.dataSets[1].data.push(leave.sl);
            return acc;
        },
        {
            chartData: {
                labels: [],
                dataSets: [
                    {
                        label: 'Vacation Leave',
                        backgroundColor: '#f87979',
                        data: [],
                    },
                    {
                        label: 'Sick Leave',
                        backgroundColor: '#e85979',
                        data: [],
                    },
                ],
            },
        }
    );
};
export const getReformattedLeaves = (data) => {
    return data.reduce(
        (acc, current) => {
            acc.chartData.labels.push(current._id.month);
            const leave = current.leaves.reduce(
                (acc_, _current) => {
                    acc_[_current.leaveType]++;
                    return acc_;
                },
                { vl: 0, sl: 0 }
            );
            acc.chartData.dataSets[0].data.push(leave.vl);
            acc.chartData.dataSets[1].data.push(leave.sl);
            return acc;
        },
        {
            chartData: {
                labels: [],
                dataSets: [
                    {
                        label: 'Vacation Leave',
                        backgroundColor: '#f87979',
                        data: [],
                    },
                    {
                        label: 'Sick Leave',
                        backgroundColor: '#e85979',
                        data: [],
                    },
                ],
            },
        }
    );
};
